import { Trans, useTranslation } from 'react-i18next';
import { ReactComponent as PadlockFilled } from 'images/icons/PadlockFilled.svg';
import './PrerequisitesTooltip.scss';

type Props = {
  prerequisitesTitles: string[];
};

export const PrerequisitesTooltip = ({ prerequisitesTitles }: Props) => {
  const { t } = useTranslation();

  const getPrerequisitesTitles = () => {
    if (prerequisitesTitles.length === 1) {
      return prerequisitesTitles[0];
    } else {
      return [prerequisitesTitles.slice(0, -1).join(', '), prerequisitesTitles.slice(-1)[0]].join(
        prerequisitesTitles.length < 2 ? '' : ` ${t('And', { ns: 'general' })} `
      );
    }
  };
  return (
    <div className='certificate-card-tooltip'>
      <PadlockFilled />
      <div style={{ textAlign: 'left', flex: 1 }}>
        {prerequisitesTitles.length === 0 ? (
          <Trans i18nKey='PurchaseCertificationTooltip' ns='learningHub' defaults='Purchase to unlock this module.' />
        ) : (
          <Trans
            i18nKey='PrerequisitesTooltip'
            ns='learningHub'
            defaults='Complete {{prerequisites}} to unlock this module.'
            values={{ prerequisites: getPrerequisitesTitles() }}
          />
        )}
      </div>{' '}
    </div>
  );
};
